exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-data-table tbody tr.v-data-table__expanded__content {\n  box-shadow: none\n}\nth {\n  text-align: left;\n}\n", ""]);

// exports
